// Best-effort decode of a Vida access-token JWT payload. Used by callsites
// that need the email claim to pre-fill the sign-in screen on next
// biometric unlock (SSO callback + magic-link exchange, which don't
// surface email in their response bodies). Returns null on any parse
// failure — the caller passes '' to promptIfEligible and pre-fill
// degrades cleanly.

const base64UrlToBase64 = (input: string): string => {
  let out = input.replace(/-/g, '+').replace(/_/g, '/');
  while (out.length % 4 !== 0) out += '=';
  return out;
};

// `atob` is available on React Native (Hermes) 0.71+ and every browser we
// ship to. The `Buffer` fallback covers older RN runtimes and Node-like
// hosts (e.g. jest without jsdom).
const decodeBase64 = (input: string): string => {
  if (typeof atob === 'function') return atob(input);
  return Buffer.from(input, 'base64').toString('utf8');
};

export const getEmailFromAccessToken = (token: string | null | undefined): string | null => {
  if (!token) return null;
  const parts = token.split('.');
  const payload = parts[1];
  if (!payload) return null;
  try {
    const claims = JSON.parse(decodeBase64(base64UrlToBase64(payload)));
    return typeof claims?.email === 'string' && claims.email.length > 0 ? claims.email : null;
  } catch {
    return null;
  }
};
